import React from 'react';
import { 
  Clock, 
  UserCheck, 
  Navigation, 
  MapPin, 
  CheckCircle,
  AlertTriangle,
  AlertCircle,
  Zap
} from 'lucide-react';
import { EmergencyStatus, SeverityLevel } from '../types';

interface StatusIndicatorProps {
  status: EmergencyStatus;
  severity?: SeverityLevel;
  className?: string;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({ 
  status, 
  severity, 
  className = '' 
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'pending':
        return {
          icon: Clock,
          text: 'Pending Assignment',
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          iconColor: 'text-yellow-600',
        };
      case 'assigned':
        return {
          icon: UserCheck,
          text: 'Responder Assigned',
          bgColor: 'bg-blue-100',
          textColor: 'text-blue-800',
          iconColor: 'text-blue-600',
        };
      case 'en-route':
        return {
          icon: Navigation,
          text: 'En Route',
          bgColor: 'bg-orange-100',
          textColor: 'text-orange-800',
          iconColor: 'text-orange-600',
        };
      case 'on-scene':
        return {
          icon: MapPin,
          text: 'On Scene',
          bgColor: 'bg-purple-100',
          textColor: 'text-purple-800',
          iconColor: 'text-purple-600',
        };
      case 'resolved':
        return {
          icon: CheckCircle,
          text: 'Resolved',
          bgColor: 'bg-green-100',
          textColor: 'text-green-800',
          iconColor: 'text-green-600',
        };
    }
  };

  const getSeverityIcon = () => {
    switch (severity) {
      case 'critical':
        return { icon: Zap, color: 'text-red-600' };
      case 'high':
        return { icon: AlertCircle, color: 'text-red-500' };
      case 'medium':
        return { icon: AlertTriangle, color: 'text-yellow-500' };
      case 'low':
        return { icon: AlertTriangle, color: 'text-blue-500' };
      default:
        return null;
    }
  };

  const statusConfig = getStatusConfig();
  const severityConfig = getSeverityIcon();
  const StatusIcon = statusConfig.icon;

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${statusConfig.bgColor} ${statusConfig.textColor} ${className}`}>
      {severity && severityConfig && (
        <severityConfig.icon className={`w-4 h-4 ${severityConfig.color}`} />
      )}
      <StatusIcon className={`w-4 h-4 ${statusConfig.iconColor}`} />
      <span>{statusConfig.text}</span>
    </div>
  );
};